import {
  Button,
  Card,
  makeStyles,
  mergeClasses,
  tokens,
} from '@fluentui/react-components';
import React, { useCallback } from 'react';
import { PersonChatRegular } from '@fluentui/react-icons';
import { pages } from '@microsoft/teams-js';
import { TEAMS_APP_ID } from '../../constants';
import { useCreateChatMutation } from '../../queries/chat';

const useStyles = makeStyles({
  wrapperStyle: {
    display: 'flex',
    flex: 1,
    gap: '10px',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
  },
});

export const RecordingGlobalActionsBar = (props: {
  className?: string;
  recordingId: string;
}) => {
  const { className, recordingId } = props;

  const { mutateAsync: createChat, isPending: isCreatingPending } =
    useCreateChatMutation();

  const createDiscussion = useCallback(async () => {
    const chat = await createChat({
      recordingId,
    });

    const pageId = 'axys.notes.chats';
    const subPageId = chat.discussionId;
    if (pages.currentApp.isSupported()) {
      await pages.currentApp.navigateTo({
        pageId,
        subPageId,
      });
    } else {
      await pages.navigateToApp({
        appId: TEAMS_APP_ID!,
        pageId,
        subPageId,
      });
    }
  }, [createChat, recordingId]);

  const styles = useStyles();

  return (
      <div className={className ? mergeClasses(styles.wrapperStyle, className) : styles.wrapperStyle}>
        <Button
          appearance="primary"
          aria-label="export"
          icon={<PersonChatRegular />}
          onClick={createDiscussion}
          disabled={isCreatingPending}
        >
          Assistant
        </Button>
      </div>
  );
};
